import MainCardContainer from './MainCardContainer';

export default MainCardContainer;
